import { toAllowedBridgeUrl } from '../utils/bridge/bridgeUrlPolicy';
import { companyScopedKey } from './bridgeCompany';

/**
 * Remembers the bridge address Acomba supplied for this launch.
 *
 * Separate from the launch assertion in `desktopAssertion.ts`, which is cleared once sign-in resolves:
 * every bridge call after that still needs the address. localStorage rather than sessionStorage because
 * acceo_web may open the callback in a different tab. Deliberately no expiry — a stale entry just fails
 * to connect, which already reads as not-connected, whereas a TTL would add a second failure mode:
 * working, then stopping mid-day.
 */

const BRIDGE_ENDPOINT_KEY = 'bridge-endpoint';

export function setBridgeEndpoint(baseUrl: string | null | undefined): void {
    const allowed = toAllowedBridgeUrl(baseUrl);
    if (allowed === null) return;

    try {
        localStorage.setItem(companyScopedKey(BRIDGE_ENDPOINT_KEY), allowed);
    } catch {
        // Private mode / quota. The configured default still applies.
    }
}

/** Re-checked on read, so a value edited in storage cannot widen where the client will call. */
export function getBridgeEndpoint(): string | null {
    try {
        const scoped = toAllowedBridgeUrl(localStorage.getItem(companyScopedKey(BRIDGE_ENDPOINT_KEY)));
        return scoped ?? toAllowedBridgeUrl(localStorage.getItem(BRIDGE_ENDPOINT_KEY));
    } catch {
        return null;
    }
}

export function clearBridgeEndpoint(): void {
    try {
        localStorage.removeItem(companyScopedKey(BRIDGE_ENDPOINT_KEY));
        localStorage.removeItem(BRIDGE_ENDPOINT_KEY);
    } catch {
        // Storage unavailable; nothing to remove.
    }
}
